export default class Playlist {
    constructor(rootElement) {
  
      window.addEventListener('DOMContentLoaded', (event) => {
        this.items = rootElement.querySelectorAll('.wp-playlist-item');
        this.stopPlayButton = rootElement.querySelector('.mejs-button');
  
        if (this.items.length > 0) {
          this.addItemsEventListener();
        }
  
        if (this.stopPlayButton) {
          this.addButtonEventListener();
        }
      });
  
      setTimeout(() => {
        const playlistCaptions = document.querySelectorAll('.wp-playlist-caption');
  
        playlistCaptions.forEach(caption => {
          const captionWidth = caption.clientWidth;
          const captionRealWidth = this.measureText(caption.innerText, 14).width;
  
          caption.style.setProperty('--caption-translate', '-' + (((captionRealWidth / captionWidth) * 100) + 10) + "%");
        });
      }, 300);
    }
  
  
  
    addItemsEventListener ( ) {
      this.items.forEach((item) => {
        item.addEventListener('click', this.checkSongPlayOrStop.bind(this))
      })
    }
  
    addButtonEventListener() {
      this.stopPlayButton.addEventListener('click', this.checkSongPlayOrStop.bind(this));
    }
  
    checkSongPlayOrStop () {
      this.removeOldPlaying();
  
      setTimeout(() => {
        const activeItem = document.querySelector('.wp-playlist-item.wp-playlist-playing');
  
        if (!activeItem) {
          return;
        }
  
        if (this.stopPlayButton.classList.contains('mejs-pause')) {
          activeItem.classList.add('wp-playlist-playing--now');
        }
      }, 200)
    }
  
    removeOldPlaying () {
      this.items.forEach((item) => {
        if(item.classList.contains('wp-playlist-playing--now')) {
          item.classList.remove('wp-playlist-playing--now');
        }
      })
    }
  
    measureText(pText, pFontSize, pStyle) {
      var lDiv = document.createElement('div');
  
      document.body.appendChild(lDiv);
  
      if (pStyle != null) {
          lDiv.style = pStyle;
      }
  
      lDiv.style.fontSize = "" + pFontSize + "px";
      lDiv.style.position = "absolute";
      lDiv.style.left = -1000;
      lDiv.style.top = -1000;
  
      lDiv.innerHTML = pText;
  
      var lResult = {
          width: lDiv.clientWidth,
          height: lDiv.clientHeight
      };
  
      document.body.removeChild(lDiv);
      lDiv = null;
  
      return lResult;
    }
  }
  